import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Modal, notification, Select, Tooltip, Pagination } from "antd";
import { EditOutlined, SearchOutlined, EyeOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

import vendorQuotation from "../../../services/vendor-quotation-service";
import { changeDocumentTitle } from "../../../utils/title";

function BrowseVendor() {

  const navigate = useNavigate();
  const editVendorQuotation = (id) => navigate(`/operations/vendor/quotation/form/${id}`);

  const [isModalshow, setIsModalShow] = useState();
  const [browses, setBrowse] = useState([]);
  const [filteredBrowse, setFilteredBrowse] = useState(browses);
  const [loading, setLoading] = useState(false);
  const [selectedDeleteRecord, setSelectedDeleteRecord] = useState(null);
  const [search, setSearch] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => text.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Validity",
      dataIndex: "validity_date",
      key: "validity_date",
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title='Edit'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => editVendorQuotation(record.id)}
            > */}
            <EditOutlined onClick={() => editVendorQuotation(record.id)}
            />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title='View'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() =>
                navigate("/operations/vendor/quotation/view/" + record.id)
              } 
            >*/}
            <EyeOutlined onClick={() =>
              navigate("/operations/vendor/quotation/view/" + record.id)
            } />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title='Delete'>
            {/* <Button
              type="primary"
              size="small"
              onClick={() => showModalHandler(record.id)}
            > */}
            <DeleteOutlined onClick={() => showModalHandler(record.id)} />
            {/* </Button> */}
          </Tooltip>
        </Space>
      ),
    },
  ];

  const showModalHandler = (record) => {
    setSelectedDeleteRecord(record);
    setIsModalShow(true);
  };

  const handleOk = async () => {
    if (!selectedDeleteRecord) return;
    const response = await vendorQuotation.deleteQuotation(
      selectedDeleteRecord
    );
    if (response.success) {
      setBrowse((prevData) =>
        prevData.filter((item) => item.id !== selectedDeleteRecord)
      );
      initialize();
      notification.success({
        message: "Success",
        description: "Vendor Quotation deleted successfully!",
        placement: "topRight",
      });
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
    setIsModalShow(false);
  };

  const handleCancel = () => {
    setIsModalShow(false);
  };

  const initialize = async (page = 1, pageSize = pagination.pageSize, search = null) => {
    setLoading(true);
    const { success, data } = await vendorQuotation.fetch(page, pageSize, search);
    setLoading(false);
    if (success) {
      setBrowse(data.data);
      setFilteredBrowse(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };


  useEffect(() => {
    changeDocumentTitle("Vendor Quotations");
    initialize(pagination.current, pagination.pageSize, search);
  }, [search]);

  return (
    <div
      style={{
        padding: "15px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Browse Vendor Quotations
        </h1>
        <Input
          placeholder="Search by Name"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>


      {/* delete */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalshow}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px", // Adjust padding for smaller size
        }}
        width={300} // Adjust modal width
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to delete this?
        </p>
      </Modal>

      <Table
        columns={columns}
        dataSource={filteredBrowse}
        loading={loading}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        // }}
        pagination={false}
        style={{ marginTop: "10px" }}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default BrowseVendor;
